import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { isClosed } from '@utils/shop';
import useShopHeaderImage from '@hooks/images/useShopHeaderImage';
import SimpleButton, { COLOR, SIZE } from '@components/SimpleButton';
import DeliveryInfo from '@shopDetails/components/DeliveryInfo';
import MenuSearchInput from '@conversion/containers/MenuSearchInput';
import DeliveryPartnerInfo from '@shopDetails/components/DeliveryPartnerInfo';
import SubHeaderSeparator from '@components/SubHeaderSeparator';
import Rating from '@components/Rating';
import ShopHeaderNotification from '../../Notification';
import BackgroundImage from '../../BackgroundImage';
import {
  Name,
  Separator,
  NameContainer,
  FooterContainer,
  Gradient,
  Body,
  ShopHeaderContainer,
  Container,
  SubHeaderContainer,
  ItemsContainer,
} from './components';
import TagsContainer from './components/TagsContainer';
import connect from './connect';

const HEADER_HEIGHT = 230;

function MainHeaderRestaurant({
  shop,
  reviewsRoute,
  show,
  showInputSearch,
  onSearchClick,
  searchPlaceholder,
  subHeader,
  children,
  showShimmer,
  weeklyDiscount,
}) {
  const displayReviewsSection = useMemo(
    () => shop?.acceptsReviews && shop?.validReviewCount > 0,
    [shop],
  );

  const backgroundImage = useShopHeaderImage(shop);

  if (showShimmer) {
    return null;
  }
  return (
    <Container show={show}>
      <ShopHeaderContainer height={HEADER_HEIGHT}>
        <BackgroundImage
          src={backgroundImage}
          isClosed={isClosed(shop)}
          height="100%"
        />
        <Gradient />
        <Body height={HEADER_HEIGHT}>
          <Separator />
          <ItemsContainer>
            <NameContainer>
              <TagsContainer>
                <DeliveryPartnerInfo />
              </TagsContainer>
              {Boolean(shop?.name) && <Name>{shop.name}</Name>}
              <DeliveryInfo />
            </NameContainer>
            {showInputSearch && (
              <MenuSearchInput
                onClick={onSearchClick}
                placeholder={searchPlaceholder}
                disabled
                background="primary"
              />
            )}
          </ItemsContainer>
        </Body>
      </ShopHeaderContainer>
      {subHeader && <SubHeaderContainer>{subHeader}</SubHeaderContainer>}
      {displayReviewsSection && (
        <>
          {subHeader && <SubHeaderSeparator />}
          <FooterContainer>
            <Rating score={shop?.generalScore} />
            <Link to={reviewsRoute}>
              <SimpleButton
                label={`${shop?.validReviewCount} opiniones`}
                color={COLOR.SECONDARY}
                size={SIZE.SMALL}
                isAction
              />
            </Link>
          </FooterContainer>
        </>
      )}
      <ShopHeaderNotification shop={shop} weeklyDiscount={weeklyDiscount} />
      {children}
    </Container>
  );
}

MainHeaderRestaurant.propTypes = {
  show: PropTypes.bool,
  shop: PropTypes.object.isRequired,
  reviewsRoute: PropTypes.string.isRequired,
  onSearchClick: PropTypes.func,
  searchPlaceholder: PropTypes.string,
  subHeader: PropTypes.node,
  children: PropTypes.node,
  showInputSearch: PropTypes.bool,
  showShimmer: PropTypes.bool,
  weeklyDiscount: PropTypes.shape,
};

MainHeaderRestaurant.defaultProps = {
  show: true,
  searchPlaceholder: '',
  showInputSearch: true,
  showShimmer: false,
  onSearchClick: () => {},
};

export default connect(MainHeaderRestaurant);
